/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DeletedInputs */

const en_settings_apikeys_deleted = /** @type {(inputs: Settings_Apikeys_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key deleted`)
};

const zh_settings_apikeys_deleted = /** @type {(inputs: Settings_Apikeys_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密钥已删除`)
};

/**
* | output |
* | --- |
* | "Key deleted" |
*
* @param {Settings_Apikeys_DeletedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_deleted = /** @type {((inputs?: Settings_Apikeys_DeletedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DeletedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_deleted(inputs)
	return zh_settings_apikeys_deleted(inputs)
});
export { settings_apikeys_deleted as "settings.apikeys.deleted" }